<template>
  <FluxoCompletoComponent :title="'Fluxo Completo'" />
</template>

<script>
import FluxoCompletoComponent from "../components/FluxoCompletoComponent.vue";
export default {
  components: {
    FluxoCompletoComponent,
  },
};
</script>

<style></style>
